<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-5 is-offset-1">
                    <div class="columns">
                        <div class="column is-10">
                            <br>
                            <br>
                            <br>
                            <br>
                    <h3 class="is-size-1 has-text-primary section-title">WebBank Brand Partners </h3>
                    <br>
                    <p class="">WebBank is a national issuer of credit products to business borrowers through its Brand platforms.</p>
                    <br>
                    <p class="">Click on the logos below to learn more about each business credit product we offer.
                        To learn more about consumer credit products we offer,
                        <router-link to="/brand-partners" title="Our Consumer Credit Products">click here</router-link>.
                    </p>
                        </div>
                    </div>
                    <br>
                </div>
                <div class="column is-5">
                    <br>
                    <img src="https://assets.webbank.com/bizbrand3.png" class="body-image"  alt="WebBank Business Brand Partners" />
                </div>
            </div>
        </div>
    </section>
            <br>
    <section class="section grey-section">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div class="has-text-centered">
                    <h3 class="is-size-1 has-text-white section-title">Our Partners</h3>
                    <br>

                    <div class="columns">
                        <div class="column">
                            <partner-bill @link-click="clickOutWarning"></partner-bill>
                        </div>
                        <div class="column">
                            <partner-can-capital @link-click="clickOutWarning"></partner-can-capital>
                        </div>
                        <div class="column">
                            <partner-ontap @link-click="clickOutWarning"></partner-ontap>
                        </div>
                        <div class="column">
                            <partner-libertas @link-click="clickOutWarning"></partner-libertas>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <partner-paypal @link-click="clickOutWarning"></partner-paypal>
                        </div>
                        <div class="column">
                            <partner-peac @link-click="clickOutWarning"></partner-peac>
                        </div>
                        <div class="column">
                            <partner-shopify @link-click="clickOutWarning"></partner-shopify>
                        </div>
                        <div class="column">
                            <partner-toast @link-click="clickOutWarning"></partner-toast>
                        </div>
                    </div>

                    </div>
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </section>

    <careers-hero parent="business-brands"></careers-hero>


<div class="modal" :class="{'is-active': clickout_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box">
          <h2 class="box-title">You are leaving our site!</h2>
          <br>
          <p>You will be linking to another website not owned or operated by WebBank.</p>
          <br>
          <p>WebBank is not responsible for the availability or content of this website and does not represent either the linked website or you, should you enter into a transaction.</p>
          <br>
          <p>The inclusion of any hyperlink does not imply any endorsement, investigation, verification or monitoring by WebBank of any information in any hyperlinked site. We encourage you to review their privacy and security policies which may differ from WebBank.</p>
          <br>
          <p>If you click &quot;Proceed&quot;, the link will open in a new window.</p>
          <br>
            <br><div class="field is-grouped">
            <div class="control">
                <button class="button is-link" @click="doClickout">Proceed</button>
            </div>
            <div class="control">
                <button class="button is-link is-light" @click="clickout_modal = false">Cancel</button>
            </div>
</div>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="clickout_modal = false"></button>
</div>


</template>

<script>
import PartnerCanCapital from '@/components/PartnerCanCapital.vue'
import PartnerShopify from '@/components/PartnerShopify.vue';
import PartnerToast from '@/components/PartnerToast.vue';
import PartnerPaypal from '@/components/PartnerPaypal.vue';
import PartnerLibertas from '@/components/PartnerLibertas.vue';
import PartnerOntap from '@/components/PartnerOntap.vue';
import PartnerBill from '@/components/PartnerBill.vue';
import PartnerPeac from '@/components/PartnerPeac.vue';
import CareersHero from '@/components/CareersHero.vue';
export default {
    components: {
    PartnerCanCapital,
    PartnerShopify,
    PartnerToast,
    PartnerPaypal,
    PartnerLibertas,
    PartnerOntap,
    PartnerBill,
    PartnerPeac,
    CareersHero
},

    created() {
        document.title = "Business Brand Partners - WebBank";
    },

    data: function () {
        return {
            clickout_modal: false,
            clickout_url: null,
        }
    },

    methods: {
        clickOutWarning: function (url) {
            this.clickout_url = url;
            this.closeAllPartnerModals();
            this.clickout_modal = true;
        },


        doClickout: function () {
            this.clickout_modal = false;
            window.open(this.clickout_url, "_blank");
        },

        closeAllPartnerModals: function () {
            this.avant_modal = false;
        }
    }
}
</script>
